module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "width": "90%",
      "margin": "auto"
    }
  }, [_c('p', {
    staticClass: "stepTitle"
  }, [_vm._v("活动信息")]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称：",
      "prop": "Title"
    }
  }, [_c('el-input', {
    attrs: {
      "width": "100%",
      "placeholder": "请输入活动名称（5-30个字）",
      "maxlength": "30",
      "minlength": "5",
      "disabled": (_vm.setType == 2 || _vm.setType == 3) ? true : false
    },
    model: {
      value: (_vm.ruleForm.Title),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "Title", $$v)
      },
      expression: "ruleForm.Title"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动时间：",
      "prop": "value1"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%",
      "cursor": "pointer",
      "background": "#fff",
      "border": "1px solid #eee"
    },
    attrs: {
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptionsStart,
      "disabled": (_vm.setType == 2 || _vm.setType == 3) ? true : false
    },
    on: {
      "change": _vm.changeActiveTime
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.whichRole) ? _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.newLmhd),
      expression: "!newLmhd"
    }],
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "所在城市：",
      "prop": "chengshi"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.options,
      "filterable": "",
      "clearable": "",
      "disabled": (_vm.setType == 2 || _vm.setType == 3) ? true : false
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.chengshi),
      callback: function($$v) {
        _vm.chengshi = $$v
      },
      expression: "chengshi"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "uploadActiveForm",
    attrs: {
      "label": "活动Banner：",
      "prop": "bannerImgUrl"
    }
  }, [_c('div', {
    staticClass: "uploadActive"
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isdisabled),
      expression: "isdisabled"
    }],
    staticClass: "avatar-uploader activeUploadImg",
    attrs: {
      "action": "",
      "show-file-list": false,
      "disabled": (_vm.setType == 2 || _vm.setType == 3) ? true : false,
      "before-upload": function (file) { return _vm.beforeAvatarUpload(file, 1); }
    }
  }, [(_vm.bannerImgUrl) ? _c('div', {
    staticClass: "bannerImgUrl"
  }, [_c('img', {
    staticStyle: {
      "width": "165px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.bannerImgUrl
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.bannerImgUrl) ? _c('div', {
    staticClass: "bannerImgUrl"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888",
      "line-height": "10px"
    }
  }, [_vm._v(" 建议尺寸：1200*675，支持的图片格式：jpg、png。 ")])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "uploadActiveForm",
    attrs: {
      "label": "分享封面：",
      "prop": "fxfmImgUrl"
    }
  }, [_c('div', {
    staticClass: "uploadActive"
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isdisabled),
      expression: "isdisabled"
    }],
    staticClass: "avatar-uploader activeUploadImg",
    attrs: {
      "action": "",
      "show-file-list": false,
      "disabled": (_vm.setType == 2 || _vm.setType == 3) ? true : false,
      "before-upload": function (file) { return _vm.beforeAvatarUpload(file, 2); }
    }
  }, [(_vm.fxfmImgUrl) ? _c('div', {
    staticClass: "fxfmImgUrl"
  }, [_c('img', {
    staticStyle: {
      "width": "165px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.fxfmImgUrl
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.fxfmImgUrl) ? _c('div', {
    staticClass: "fxfmImgUrl"
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888",
      "line-height": "10px"
    }
  }, [_vm._v(" 封面图片尺寸比例要求为:1000*800，支持的图片格式：jpg、png；最大不超过5MB。")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动类型：",
      "prop": "region"
    }
  }, [_c('el-table', {
    staticStyle: {
      "height": "auto"
    },
    attrs: {
      "data": _vm.ActivityFormRelationDTOs,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "活动类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.ActivityFormName
          }
        }, [_vm._v(_vm._s(scope.row.ActivityFormName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动标题",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.Title
          }
        }, [_vm._v(_vm._s(scope.row.Title))])]
      }
    }])
  }), _vm._v(" "), ((_vm.setType == 2 || _vm.setType == 3) ? false : true) ? _c('el-table-column', {
    attrs: {
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.deleteActiveType(scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\r\n              ")])]
      }
    }], null, false, 3854008447)
  }, [_c('template', {
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "color": "#6786b4",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.addActiveTypeDiaShow
    }
  }, [_vm._v("新增活动类型")])])], 2) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "小标题（选填）："
    }
  }, [_vm._l((_vm.journalArr), function(item, index) {
    return _c('el-form', {
      key: index
    }, [_c('el-form-item', {
      staticStyle: {
        "width": "50%"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "placeholder": "请输入小标题（10字以内）",
        "maxlength": "10",
        "disabled": (_vm.setType == 2 || _vm.setType == 3) ? true : false
      },
      model: {
        value: (item.title),
        callback: function($$v) {
          _vm.$set(item, "title", $$v)
        },
        expression: "item.title"
      }
    }), _vm._v(" "), _c('el-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index > 0),
        expression: "index > 0"
      }],
      staticClass: "shanBtn",
      attrs: {
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.shanchu(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete"
    }), _vm._v(" 刪除")])], 1), _vm._v(" "), _c('div', {
      staticClass: "upPictures"
    }, [_vm._l((item.images), function(img, index) {
      return _c('div', {
        key: index,
        staticClass: "multigraph",
        attrs: {
          "data-img": img
        }
      }, [_c('el-image', {
        staticStyle: {
          "width": "100px",
          "height": "100px"
        },
        attrs: {
          "src": img
        }
      }), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: ((_vm.setType == 2 || _vm.setType == 3) ? false : true),
          expression: "(setType==2 || setType==3)?false:true"
        }],
        staticClass: "chahao",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.deldetail(item, index)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": require("../../assets/img/aicon36.png")
        }
      })])], 1)
    }), _vm._v(" "), (item.images.length < 10) ? _c('el-upload', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((_vm.setType == 2 || _vm.setType == 3) ? false : true),
        expression: "(setType==2 || setType==3)?false:true"
      }],
      attrs: {
        "action": "",
        "multiple": "",
        "accept": ".png, .jpg,.jpeg",
        "limit": 10,
        "before-upload": function (file) { return _vm.multiGraphUpload(file, item); }
      }
    }, [_c('i', {
      staticClass: "el-icon-plus upBtn"
    })]) : _vm._e()], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#888"
      }
    }, [_vm._v("建议宽为1200像素，高不限，支持的图片格式：jpg、png。最大不超过5MB，最多支持上传10张。")])], 1)
  }), _vm._v(" "), (_vm.journalArr.length < 10) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.setType == 2 || _vm.setType == 3) ? false : true),
      expression: "(setType==2 || setType==3)?false:true"
    }],
    staticClass: "primarybtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addJournal()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" 再增加一条")])], 1) : _vm._e()], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('ruleForm')
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "search_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toNextStep('ruleForm')
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "IdenticalPadding",
    attrs: {
      "width": "30%",
      "title": "新增活动类型",
      "before-close": _vm.cancelActiveType,
      "visible": _vm.addInnerVisible,
      "modal-append-to-body": false,
      "modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.addInnerVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addActiveTypeForm",
    staticClass: "eleWidthInput",
    attrs: {
      "model": _vm.addActiveTypeForm,
      "width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动类型：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择活动类型"
    },
    on: {
      "change": _vm.changeActivityForm
    },
    model: {
      value: (_vm.addActiveTypeForm.typeId),
      callback: function($$v) {
        _vm.$set(_vm.addActiveTypeForm, "typeId", $$v)
      },
      expression: "addActiveTypeForm.typeId"
    }
  }, _vm._l((_vm.newActivityFormList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动标题：",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入活动标题",
      "maxlength": "10"
    },
    model: {
      value: (_vm.addActiveTypeForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addActiveTypeForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "addActiveTypeForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelActiveType
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "search_btn",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.endAddActiveType
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.isShowYszt,
      "title": "查看大图"
    },
    on: {
      "update:visible": function($event) {
        _vm.isShowYszt = $event
      },
      "closed": _vm.clearImg
    }
  }, [_c('div', {
    staticClass: "imgDialog slither"
  }, [_c('img', {
    staticStyle: {
      "width": "auto",
      "height": "auto",
      "max-width": "30%"
    },
    attrs: {
      "src": _vm.showImageUrl
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-145b5646!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/addOrEditActive/oneStep.vue
// module id = 1637
// module chunks = 3